import type { RimBoltPattern } from '@navio/nsdk';

/** Catalog text can include units and provenance after the actual pattern. */
export const parseBoltPattern = (value: string): RimBoltPattern | null => {
  const match = /^\s*(\d{1,2})\s*[x×]\s*(\d+(?:[.,]\d+)?)(?:\s*mm)?(?=\s*(?:$|·|\())/i.exec(value);
  const boltsText = match?.[1];
  const diameterText = match?.[2];
  if (!boltsText || !diameterText) {
    return null;
  }
  const bolts = Number(boltsText);
  const diameter = Number(diameterText.replace(',', '.'));
  return bolts > 0 && diameter > 0 && Number.isFinite(diameter) ? { bolts, diameter } : null;
};
